export default __webpack_public_path__ + "static/icon-climate-action-15a2806f39eac5c4f303df86e7bc1849.svg";